import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Envoyer / publier — avion en papier duotone */
export const SendIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Aile arrière menthe */}
      <path d="M3 11l8 1.5 9-9.5L3 11z" fill="var(--equiply-icon-bg)" />
      {/* Forme avion */}
      <path d="M20 3L11 12.5l3 7L20 3z" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M20 3L3 11l8 1.5L20 3z" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
);
SendIcon.displayName = "SendIcon";
